"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[127],{

/***/ 33451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64761);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36972);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34065);


function useDxbTheme() {
    var theme = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_0__/* .useMantineTheme */ .rZ)();
    var colorScheme = (0,_mantine_core__WEBPACK_IMPORTED_MODULE_1__/* .useMantineColorScheme */ .X)().colorScheme;
    var isDark = colorScheme === "dark";
    var isLight = colorScheme === "light";
    var isSmallScreen = (0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useMediaQuery */ .a)("(min-width: 500px)");
    return {
        isDark: isDark,
        isLight: isLight,
        colorScheme: colorScheme,
        theme: theme,
        isSmallScreen: isSmallScreen
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useDxbTheme);


/***/ }),

/***/ 66127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* binding */ PropertyItemCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(97564);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Card/Card.js + 4 modules
var Card = __webpack_require__(21017);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/BackgroundImage/BackgroundImage.js
var BackgroundImage = __webpack_require__(49563);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Badge/Badge.js + 1 modules
var Badge = __webpack_require__(17789);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Group/Group.js + 1 modules
var Group = __webpack_require__(71232);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(19236);
// EXTERNAL MODULE: ./node_modules/@tabler/icons/icons-react/dist/index.esm.js
var index_esm = __webpack_require__(63991);
// EXTERNAL MODULE: ./node_modules/@mantine/next/esm/NextLink.js
var NextLink = __webpack_require__(8798);
// EXTERNAL MODULE: ./src/core/router/AppRoutes.ts
var AppRoutes = __webpack_require__(84396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/ActionIcon/ActionIcon.js + 1 modules
var ActionIcon = __webpack_require__(49834);
;// CONCATENATED MODULE: ./src/core/components/common/CToggle.tsx





var CToggle = function(param) {
    var onIcon = param.onIcon, offIcon = param.offIcon, onToggle = param.onToggle, initialState = param.initialState, _loading = param.loading, props = param.props;
    var ref = (0,react.useState)(false), active = ref[0], setActive = ref[1];
    var toggleState = function() {
        setActive(function(favorite) {
            return !favorite;
        });
        onToggle(active);
    };
    (0,react.useEffect)(function() {
        if (initialState) {
            setActive(initialState);
        }
    }, [
        initialState
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
        position: "center",
        my: "xl",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionIcon/* ActionIcon */.A, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            loading: _loading
        }, props), {
            onClick: function() {
                // console.log(active, 'activeSIM');
                toggleState();
            },
            children: active ? offIcon : onIcon
        }))
    });
};

// EXTERNAL MODULE: ./src/core/utils/dxb-utils.ts
var dxb_utils = __webpack_require__(10646);
// EXTERNAL MODULE: ./src/core/hooks/use-dxb-theme.ts
var use_dxb_theme = __webpack_require__(33451);
// EXTERNAL MODULE: ./src/features/common/hooks/use-user-data.ts
var use_user_data = __webpack_require__(85992);
// EXTERNAL MODULE: ./src/generated/graphql.tsx
var graphql = __webpack_require__(89402);
;// CONCATENATED MODULE: ./src/features/common/FavButton.tsx












var FavButton = function(param) {
    var _propertyId = param.propertyId, isFav = param.isFav;
    var isDark = (0,use_dxb_theme/* default */.Z)().isDark;
    var ref = (0,use_user_data/* default */.Z)(), getUserId = ref.getUserId, getUserPropIds = ref.getUserPropIds, setUserPropIds = ref.setUserPropIds;
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useSaveUserFavPropertyMutation */.aq)(), 1), saveUserFavProperty = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useRemoveUserFavPropertyMutation */.ju)(), 1), removeUserFavProperty = ref3[0];
    var removeFav = function() {
        setIsLoading(true);
        removeUserFavProperty({
            variables: {
                userId: getUserId().toString(),
                propertyId: _propertyId
            }
        }).then(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var data, ids;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    data = param.data;
                    // console.log('D>> ', data);
                    setIsLoading(false);
                    if (data.removeUserFavProperty.error) {
                        console.error("Error ".concat(data.removeUserFavProperty.error));
                    }
                    //REMOVE THE ID FROM THE LOCAL STATE
                    if (getUserPropIds()) {
                        ids = (0,dxb_utils/* filterPropertiesByIds */.ac)(_propertyId, getUserPropIds());
                        // console.log(ids, 'REMOVE IDs')
                        setUserPropIds(ids);
                    }
                    return [
                        2
                    ];
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }()).catch(function(error) {
            setIsLoading(false);
            console.error(error);
        // message.error("Error unable to reach server " + error)
        });
    };
    var addFav = function() {
        setIsLoading(true);
        saveUserFavProperty({
            variables: {
                userId: getUserId().toString(),
                propertyId: _propertyId
            }
        }).then(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var data, isAlreadyThere, oldIds, updated;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    data = param.data;
                    // console.log('D>> ', data);
                    setIsLoading(false);
                    if (data.saveUserFavProperty.error) {
                        console.error("Error ".concat(data.saveUserFavProperty.error));
                    }
                    //UPDATE THE LOCAL STATE
                    if (getUserPropIds()) {
                        isAlreadyThere = (0,dxb_utils/* filterCheckPropertiesByIds */.T5)(_propertyId, getUserPropIds());
                        if (!isAlreadyThere) {
                            oldIds = getUserPropIds();
                            updated = (0,_to_consumable_array/* default */.Z)(oldIds).concat([
                                {
                                    __typename: "PropertyIDS",
                                    property_id: _propertyId
                                }
                            ]);
                            // console.log(oldIds, 'oldIds')
                            // console.log(updated, 'updated')
                            setUserPropIds(updated);
                        }
                    }
                    return [
                        2
                    ];
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }()).catch(function(error) {
            setIsLoading(false);
            console.error(error);
        // message.error("Error unable to reach server " + error)
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CToggle, {
        initialState: isFav,
        loading: isLoading,
        onIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconHeartPlus */.IHR, {
            color: isDark ? "orange" : "orange",
            size: 32,
            stroke: 1.5
        }),
        offIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconHeartMinus */.OFw, {
            color: isDark ? "orange" : "orange",
            size: 32,
            stroke: 1.5
        }),
        onToggle: function(state) {
            if (state) {
                removeFav();
            }
            if (!state) {
                addFav();
            }
        },
        props: {
            variant: "transparent",
            size: "lg"
        }
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./src/features/common/cards/PropertyItem/PropertyItemCard.styles.ts


/**
 * This is where we are handling styling for
 * property card - in featured scroller and properties page grid
 *
 * */ /* harmony default export */ var PropertyItemCard_styles = ((0,create_styles/* createStyles */.k)(function(theme, _params, getRef) {
    // const image = getRef('image');
    return {
        mainCard: {
            borderColor: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[5],
            borderStyle: "solid",
            borderWidth: 1
        },
        featuredScrollerCard: {
            // minWidth: 320,
            border: "none",
            marginBottom: theme.spacing.xs,
            marginTop: theme.spacing.xs,
            boxShadow: "none",
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
            borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
            borderStyle: "solid",
            borderWidth: 1
        },
        propertyItemCard: {
            // minWidth: 320,
            border: "none",
            marginBottom: theme.spacing.xs,
            marginTop: theme.spacing.xs,
            boxShadow: "none",
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
            borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
            borderStyle: "solid",
            borderWidth: 1
        },
        cardTopSection: {
            borderRadius: theme.radius.xs,
            display: "flex",
            height: 350,
            overflow: "hidden",
            // alignItems: 'center',
            // justifyContent: 'center',
            borderBottom: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3])
        },
        cardBackgroundImage: {
            transition: "box-shadow 150ms ease-in-out, transform 100ms ease-in-out",
            ":hover": {
                transform: "scale(1.05)",
                transition: "all .5s"
            }
        },
        label: {
            marginBottom: theme.spacing.xs,
            marginTop: theme.spacing.xs,
            lineHeight: 1,
            fontWeight: 400,
            fontSize: theme.fontSizes.xs,
            letterSpacing: -0.25,
            textTransform: "uppercase"
        },
        cardBottomSection: {
            padding: theme.spacing.md
        },
        cardFeaturesSectionTop: (0,_define_property/* default */.Z)({
            padding: theme.spacing.md
        }, theme.fn.smallerThan("sm"), {
            display: "flex",
            justifyContent: "center"
        }),
        cardFeaturesSectionBottom: (0,_define_property/* default */.Z)({
            padding: theme.spacing.md
        }, theme.fn.smallerThan("sm"), {
            display: "flex",
            justifyContent: "center",
            paddingBottom: 30
        }),
        featuredBadge: {
            position: "absolute",
            width: "fit-content",
            height: 32,
            lineHeight: 1,
            padding: 10,
            top: 10,
            left: 10,
            fontWeight: 400,
            fontSize: 14,
            textTransform: "capitalize"
        },
        featuredBadgeText: {
            color: theme.white
        },
        /*icon: {
            marginLeft: -3,
            color: theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[5],
        },*/ /*featuresText: {
            marginTop: 6,
            display: 'block',
            textAlign: 'center',
            fontSize: 12,
        },*/ /*featuresNumber: {
            display: 'inline-block',
            verticalAlign: 'top',
            margin: 0,
            textAlign: 'center',
            fontSize: 20,
            fontWeight: 200,
            height: 80,
        },*/ priceGroup: {
            position: "absolute",
            top: 268,
            paddingLeft: 20,
            paddingRight: 20,
            height: 82,
            // paddingBottom: 6,
            width: "100%",
            borderBottomLeftRadius: theme.radius.xs,
            borderBottomRightRadius: theme.radius.xs,
            borderRadius: theme.radius.xs,
            background: theme.fn.gradient({
                from: theme.fn.rgba(theme.white, 0),
                to: theme.fn.rgba(theme.black, 0.9),
                deg: 180
            })
        },
        priceCurrency: {
            marginBottom: 0,
            position: "relative",
            bottom: 8,
            fontSize: 14,
            fontWeight: 400,
            marginRight: 4,
            color: theme.white
        },
        priceAmount: {
            marginBottom: 0,
            marginTop: 0,
            fontSize: 26,
            textAlign: "center",
            fontWeight: 400,
            color: theme.white
        },
        priceDuration: {
            marginTop: 0,
            position: "relative",
            top: 4,
            fontSize: 12,
            fontWeight: 400,
            color: theme.white
        },
        propertyCardTitle: (0,_define_property/* default */.Z)({
            // display: 'inline-flex',
            // height: 26,
            // overflow: 'hidden',
            ":hover": {
                color: theme.colors.orange[5]
            }
        }, theme.fn.smallerThan("sm"), {
            // height: '100%',
            textAlign: "center"
        }),
        titleLocation: (0,_define_property/* default */.Z)({
            display: "inline-flex",
            width: "100%",
            overflow: "hidden",
            gap: theme.spacing.xs,
            paddingTop: theme.spacing.xs,
            flexWrap: "inherit"
        }, theme.fn.smallerThan("sm"), {
            justifyContent: "center"
        }),
        h2: (0,_define_property/* default */.Z)({
            fontSize: 13,
            height: 26,
            letterSpacing: 0.3,
            color: theme.colorScheme === "dark" ? theme.colors.gray[5] : theme.colors.dark[4]
        }, theme.fn.smallerThan("sm"), {
            height: "100%",
            textAlign: "center"
        }),
        features: {
            display: "inline-flex",
            alignItems: "center",
            margin: 0,
            // marginRight: 20,
            textAlign: "left",
            fontSize: 14,
            fontWeight: 300,
            color: theme.colorScheme === "dark" ? theme.colors.gray[5] : theme.colors.dark[4]
        },
        icon: {
            color: theme.colorScheme === "dark" ? theme.colors.gray[5] : theme.colors.gray[5],
            marginRight: 4
        },
        textHidden: (0,_define_property/* default */.Z)({}, theme.fn.smallerThan("xs"), {
            display: "none"
        }),
        textNumber: {
            marginRight: 4
        }
    };
}));

// EXTERNAL MODULE: ./src/core/providers/BookingStateProvider.tsx + 1 modules
var BookingStateProvider = __webpack_require__(97771);
;// CONCATENATED MODULE: ./src/features/common/cards/PropertyItem/PropertyItemCard.tsx










/**
 * IMPL IN:
 *
 * FeaturedScroller
 * PropertiesLanding
 * SearchLanding
 *
 * */ var PropertyItemCard = function(param) {
    var propertyId = param.propertyId, name = param.name, address = param.address, thumb = param.thumb, amount = param.amount, currency = param.currency, details = param.details, isFeatured = param.isFeatured, isPropertyPage = param.isPropertyPage, isFavVisible = param.isFavVisible, isFav = param.isFav, settings = param.settings;
    var resetInternalState = function resetInternalState() {
        resetPrices();
        resetBookingInfo();
    };
    var classes = PropertyItemCard_styles().classes;
    var ref = (0,BookingStateProvider/* useBookingState */.hg)(), resetBookingInfo = ref.resetBookingInfo, resetPrices = ref.resetPrices; // LOCAL CALCULATIONS
    /*const featureDetailsData: Feature[] = [
        { label: formatTitle(details?.bed_rooms, 'Bedroom'), value: details.bed_rooms, icon: IconBed },
        { label: formatTitle(details?.bath_rooms, 'Bathroom'), value: details.bath_rooms, icon: IconBath },
        { label: formatTitle(details?.max_occupancy, 'Guest'), value: details.max_occupancy, icon: IconHotelService },
    ];*/ var featureDetailsFirstData = [
        {
            label: (0,dxb_utils/* formatTitle */.Ui)(details === null || details === void 0 ? void 0 : details.bed_rooms, "Bed"),
            value: details.bed_rooms,
            icon: index_esm/* IconBed */.rqh
        },
        {
            label: (0,dxb_utils/* formatTitle */.Ui)(details === null || details === void 0 ? void 0 : details.bath_rooms, "Bath"),
            value: details.bath_rooms,
            icon: index_esm/* IconBath */.EfN
        },
        {
            label: (0,dxb_utils/* formatTitle */.Ui)(details === null || details === void 0 ? void 0 : details.max_occupancy, "Guest"),
            value: details.max_occupancy,
            icon: index_esm/* IconHotelService */.dO
        }, 
    ];
    var featureDetailsFirst = featureDetailsFirstData.map(function(feature) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
            align: "left",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                className: classes.features,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(feature.icon, {
                        size: 26,
                        stroke: 1.1,
                        className: classes.icon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: classes.textNumber,
                        children: feature.value
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: feature.label
                    })
                ]
            })
        }, feature.label);
    });
    var featureDetailsSecondData = [
        {
            label: "m\xb2",
            value: details.size,
            icon: index_esm/* IconRuler */.CBt
        },
        {
            label: (0,dxb_utils/* formatTitleNoS */.nA)(settings.minimumNights, "Nights Minimum"),
            value: settings.minimumNights,
            icon: index_esm/* IconMoonStars */.zG9
        }, 
    ];
    var featureDetailsSecond = featureDetailsSecondData.map(function(feature) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* Stack */.K, {
            align: "left",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                className: classes.features,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(feature.icon, {
                        size: 26,
                        stroke: 1.1,
                        className: classes.icon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: classes.textNumber,
                        children: feature.value
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: feature.label
                    })
                ]
            })
        }, feature.label);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* Card */.Z, {
        radius: "xs",
        className: isPropertyPage ? classes.propertyItemCard : classes.featuredScrollerCard,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* Card.Section */.Z.Section, {
                className: classes.cardTopSection,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundImage/* BackgroundImage */.X, {
                        className: classes.cardBackgroundImage,
                        title: name,
                        radius: "xs",
                        src: thumb || "./images/placeholder-600x300.jpg",
                        component: NextLink/* NextLink */.p,
                        onClick: function() {
                            resetInternalState();
                        },
                        href: (0,AppRoutes/* getPageRoute */.ul)(AppRoutes/* AppRoutes.PROPERTIES */.$w.PROPERTIES, settings.slug),
                        target: "_self"
                    }),
                    isFeatured && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                        className: classes.featuredBadge,
                        radius: "xs",
                        variant: "filled",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            className: classes.featuredBadgeText,
                            children: "Featured"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                        className: classes.priceGroup,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                style: {
                                    flex: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: classes.priceCurrency,
                                        children: currency
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: classes.priceAmount,
                                        children: amount
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: classes.priceDuration,
                                        children: "/ night"
                                    })
                                ]
                            }),
                            isFavVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(FavButton, {
                                propertyId: propertyId,
                                isFav: isFav
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* Card.Section */.Z.Section, {
                pt: 10,
                pb: 0,
                className: classes.cardBottomSection,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        className: classes.propertyCardTitle,
                        title: name,
                        component: NextLink/* NextLink */.p,
                        onClick: function() {
                            resetInternalState();
                        },
                        href: (0,AppRoutes/* getPageRoute */.ul)(AppRoutes/* AppRoutes.PROPERTIES */.$w.PROPERTIES, settings.slug),
                        target: "_self",
                        m: 0,
                        weight: 400,
                        lineClamp: 1,
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                        className: classes.titleLocation,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                            lineClamp: 1,
                            className: classes.h2,
                            order: 2,
                            children: address
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card.Section */.Z.Section, {
                pt: 10,
                pb: 0,
                className: classes.cardFeaturesSectionTop,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                    spacing: 16,
                    position: "left",
                    children: featureDetailsFirst
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card.Section */.Z.Section, {
                pt: 10,
                pb: 20,
                className: classes.cardFeaturesSectionBottom,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                    spacing: 20,
                    position: "left",
                    children: featureDetailsSecond
                })
            })
        ]
    });
};


/***/ })

}]);